import React from 'react'

import { ErrorBoundary, useGlobalCopyStore } from '../../common'
import { type HelpContentProps } from '../../core'

import { Header } from './content'
import { contentSection } from './content/section'

export const HelpContent: React.FC<HelpContentProps> = ({
  copy,
  hasRequestButton = false,
  onNavigateToList,
  onRequestSupport,
  topicInfo: { category, pageTitle, topicKey, guid },
}) => {
  const { help: helpCopy } = useGlobalCopyStore()
  const ContentComponent = contentSection[guid as keyof typeof contentSection] || null

  return (
    <React.Fragment>
      <Header
        buttonCopy={copy.request_support}
        hasRequestButton={hasRequestButton}
        onNavigateToList={onNavigateToList}
        onRequestSupport={onRequestSupport}
        title={category}
        topicTitle={pageTitle}
      />
      <ErrorBoundary>
        {ContentComponent && <ContentComponent copy={helpCopy} topicKey={topicKey} />}
      </ErrorBoundary>
    </React.Fragment>
  )
}
